function validatePriceFieldsUnconfigured($, minPrice, maxPrice) {
    markFieldAsNoError('rowError', minPrice.parentNode);
    markFieldAsNoError('rowError', maxPrice.parentNode);

    if (!$.isNumeric(minPrice.value) && minPrice.value !== '') {
        markFieldAsError(
            'rowError',
            maxPrice.parentNode,
            maxPrice.parentNode.querySelector('.popupError'),
            maxPrice.parentNode.getAttribute('data-priceerror'),
        );

        return false;
    }

    if (!$.isNumeric(maxPrice.value) && maxPrice.value !== '') {
        markFieldAsError(
            'rowError',
            maxPrice.parentNode,
            maxPrice.parentNode.querySelector('.popupError'),
            maxPrice.parentNode.getAttribute('data-priceerror'),
        );

        return false;
    }

    if ($.isNumeric(maxPrice.value) && $.isNumeric(minPrice.value)) {
        // Maksimalna cijena moze biti manja od minimalne samo kada je jednaka 0, u tom slucaju se ignorira gornja granica
        if (parseInt(minPrice.value, 10) > parseInt(maxPrice.value, 10) && parseInt(maxPrice.value, 10) !== 0) {
            markFieldAsError(
                'rowError',
                maxPrice.parentNode,
                maxPrice.parentNode.querySelector('.popupError'),
                maxPrice.parentNode.getAttribute('data-greatererror'),
            );

            return false;
        }
    }

    return true;
}

function validatePersonsFieldUnconfigured($, persons) {
    const selectedPersons = $(persons).val();
    if (!$.isNumeric(selectedPersons) && selectedPersons !== '') {
        markFieldAsError('errorField', persons.parentNode);

        return false;
    }

    markFieldAsNoError('errorField', persons.parentNode);

    return true;
}

function markFieldAsError(className, element, popUp, errorMessage) {
    element.classList.add(className);

    if (popUp !== undefined && errorMessage !== undefined && errorMessage !== '') {
        popUp.innerHTML = errorMessage;
    }
}

function markFieldAsNoError(className, element) {
    element.classList.remove(className);
}

const validatePriceFields = (minPrice, maxPrice) => validatePriceFieldsUnconfigured.bind(null, $, minPrice, maxPrice);
const validatePersonsField = (persons) => validatePersonsFieldUnconfigured.bind(null, $, persons);

export {
    validatePriceFieldsUnconfigured,
    validatePersonsFieldUnconfigured,
    validatePriceFields,
    validatePersonsField,
    markFieldAsError,
    markFieldAsNoError,
};
